const jaJPJson = {
  common: {
    add: "追加",
    edit: "編集",
    view: "表示",
    update: "更新",
    apply: "反映",
    reset: "リセット",
    delete: "削除",
    search: "検索",
    menu: "メニュー",
    actions: "操作",
    noDataAvailable: "利用可能なデータがありません",
    noOptions: "No options",
    loadingText: "データを読み込んでいます。お待ちください。",
    cancel: "キャンセル",
    select: "選択",
    close: "閉じる",
    save: "保存",
    yes: 'はい',
    no: 'いいえ',
    expand: "展開",
    collapse: "折りたたみ",
    downloadPDF: "PDFダウンロード",
    downloadCSV: "CSVダウンロード",
    downloadExcel: "Excelダウンロード",
    tips: {
      downloadFailed: "ダウンロードに失敗しました。"
    },
    tip: {
      addSuccess: "追加が完了しました。",
      addFailed: "追加ができませんでした。",
      updateSuccess: "更新が完了しました。",
      updateFailed: "更新ができませんでした。",
      revertSuccess: "元の状態に戻すことに成功しました。",
      revertFailed: "元の状態に戻せませんでした。",
      deleteSuccess: "削除が完了しました。",
      deleteFailed: "削除ができませんでした。",
      deletion: "削除理由を入力してください。",
      limit_2000: "最大文字数2000文字を超えています。",
      selectOneItem: "1つの項目を選択してください。",
      selectTarget: "最初に対象を選択してください。",
      jsonError: 'JSON形式が正しくありません。正しいJSON形式で入力してください。'
    },
    jsonLabel: 'JSON',
    next: "次へ",
    disable: "使用停止にする",
    enable: "使用可能にする",
    editable: "編集可能",
    readOnly: "読み取り専用",
    status: "ステータス",
    type: "区分",
    mandatory: "必須",
    selectAll: "すべて選択",
    pleaseSelect: "Please select",
  },
  validation: {
    isRequired: "必須",
    regexErrorTip: 'Please enter a valid format',
    numberTooSmallTip: 'The value must be at least {{number}}',
    numberTooBigTip: 'The value must be at most {{number}}',
    numberIntegerOnly: 'Integer only',
    numberMaxDecimalPlaces: "No more than {{number}} decimal places",
    dateTooEarlyTip: 'The selected date must be later than {{date}}',
    dateTooLateTip: 'The selected date must be earlier than {{date}}',
    stringTooShortTip: 'The input characters must be at least {{number}}',
    stringTooLongTip: 'The input exceeds the maximum limit of {{number}}'
  },
  menu: {
    eventLibrary: "Event Library",
    timelineTemplate: "Timeline Library",
    timelineManager: "Timeline Manager",
    eventManager: "Event Manager",
  },
  timelineLibrary: {
    timeline: "Timeline",
    templateId: "Template ID",
    templateName: "Template Name",
    applicableProjectType: "Applicable Project Type",
    module: "Module",
    selectModule: "モジュールを選択",
    selectPrimaryBusinessObject: "プライマリビジネスオブジェクトを選択",
    events: "Events",
    basicInformation: "Basic Information",
    description: "Description",
    addTemplate: "Add Timeline Template",
    editTemplate: "Edit Timeline Template",
    viewTemplate: "View Timeline Template",
    view: "View",
    back: "Back",
    autoGenerated: "Auto-generated",
    templateIdTip: "Auto-generated upon creation",
    leadTimeHelper:
      "Lead time in days relative to the project planned start date (integer from 1 to 500).",
    seq: "SEQ",
    eventName: "Event Name",
    primaryBusinessObject: "Primary Business Object",
    leadTimeDays: "Lead Time (Days)",
    addEvent: "Add Event",
    selectEventName: "Select Event Name",
    leadTimePlaceholder: "e.g. 30",
    eventsSection: "Events",
    eventsRequired: "Add at least one event row before saving.",
    leadTimeInvalid:
      "Lead time must be a whole number from 1 to 500.",
    duplicateEvent: "Each event can only be added once to this template.",
    duplicateTemplateName: "A template with this name already exists.",
    invalidEventBinding:
      "This event is not eligible for the selected Primary Business Object (missing tracking events or PBO association). Replace or remove it before saving.",
    eventsEmpty: "This template does not contain any events.",
    templateNotFound: "Timeline template was not found.",
    deleteConfirmTitle: "Delete Timeline Template",
    deleteConfirmMessage:
      'Permanently remove "{{name}}" from the timeline library? This cannot be undone.',
    addSuccessTip: "Timeline template added successfully.",
    updateSuccessTip: "Timeline template updated successfully.",
    dragToReorder: "Drag to reorder",
    moveRowUp: "Move event row up",
    moveRowDown: "Move event row down",
  },
  timelineInstance: {
    addTimeline: "Add Timeline",
    viewTimeline: "View Timeline",
    basicInformation: "Basic Information",
    timelineTemplate: "Timeline Template",
    selectTemplate: "Select Timeline Template",
    templateRequired: "Please select a Timeline Template.",
    noTemplates:
      "No Timeline Templates are available for this Primary Business Object.",
    missingContext:
      "Business record context is incomplete. Open Add Timeline from the hosting module.",
    missingViewContext:
      "Business record context is incomplete. Open View Timeline Instance from the hosting module.",
    addSuccessTip: "Timeline Instance created successfully.",
    viewEmpty: "No Timeline Instance exists for this business record.",
    viewLoadFailed: "Unable to load Timeline Instance.",
    cardEvents: "Events",
    cardCompleted: "Completed",
    cardDelayed: "Delayed",
    cardUnplanned: "Unplanned",
    eventTimeline: "Events Timeline",
    trackingEvents: "Tracking Events",
    trackingEmpty: "No tracking data",
    colEventInstanceId: "Event Instance ID",
    colEventName: "Event Name",
    colPrimaryBusinessObject: "Primary Business Object",
    colPrimaryBusinessObjectType: "Primary Business Object Type",
    colBusinessObjectId: "Business Object ID",
    colMilestone: "Milestone",
    colPlannedDate: "Planned Date",
    colActualDate: "Actual Date",
    colEventStatus: "Event Status",
    milestoneYes: "Yes",
    milestoneNo: "No",
    statusCompleted: "Completed",
    statusPlanned: "Planned",
    statusDelayed: "Delayed",
    statusUnplanned: "Unplanned",
  },
  eventLibrary: {
    fieldType: 'Field Type',
    fieldTypeText: 'Text',
    fieldTypeDate: 'Date',
    moduleDefinedProperties: 'Module Defined Properties',
    optional: 'Optional',
    addProperty: 'Add Property',
    key: 'Property Name',
    value: 'Property Value',
  },
  tenantData: {
    tenantData: 'Tenant Data',
    importTenantData: 'Import Tenant Data',
    exportTenantData: 'Export Tenant Data',
    dragDropText: 'Drag & drop files here or click on select',
    selectFile: 'Select File',
    importSummary: 'Import Summary',
    errorSummary: 'Error Summary',
    importErrorIntro: 'Import was not proceed due to the following errors:',
    importSuccessMsg: 'Successfully imported Event templates: {{quantity}}.',
    duplicateEventMsg: 'Below event names already exist in {{moduleObject}}. Please change names and import again.',
  }
};

export default jaJPJson;
